import { useEffect } from 'react'
import { TextField } from '@mui/material'
import { red } from '@mui/material/colors'
import { useValidation, UseValidationProps } from 'hooks/useValidation'

type Props = UseValidationProps & {
  value: string
  onChange: (value: string) => void
  setValid: (valid: boolean) => void
  placeholder?: string | null
}
export const TextInput = ({ value, onChange, placeholder, setValid, ...props }: Props) => {
  const { register, setValue, helperText, maxLength, required, validate, error, isValid } = useValidation(props)

  useEffect(() => setValue('value', value), [value])
  useEffect(() => {
    setValid(isValid)
  }, [isValid])

  return (
    <TextField
      hiddenLabel
      fullWidth
      value={value}
      variant="outlined"
      error={error}
      placeholder={placeholder ?? ''}
      helperText={helperText}
      {...register('value', {
        onChange: e => onChange(e.target.value),
        maxLength,
        required,
        validate,
      })}
      sx={{
        '& [aria-invalid="true"]': {
          backgroundColor: red[50],
        },
      }}
    />
  )
}
